import UnderHeaderBlock from './UnderHeaderBlock';

function HomepageMainBlock() {
  const title = (
    <>
      <span>Know Your Real Amazon Profits —</span>
      <span className="text-grad-1 playfair_display italic"> Instantly</span>
    </>
  );
  return (
    <UnderHeaderBlock
      title={title}
      description="Gain Sales Insights, Grow Product Reviews, and Automate Customer Follow-Ups."
    />
  );
}

export default HomepageMainBlock;
